var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({attrs:{"render-when-empty":""}},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('span',{staticClass:"org-role-badge"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }